<div class="wrapper" [class.has-error]="error">
  <label class="title">
    <ng-content select="[title]"></ng-content>
  </label>

  <div class="field">
    <ng-content></ng-content>
  </div>

  <small class="error">
    <ng-content select="[error]"></ng-content>
  </small>
</div>
